import EmptyInsights from '@static/images/empty-state/no-insights.svg';
import { config } from '@terminal/config/app.config';
import { useTranslation } from 'react-i18next';

import styles from './ScheduleDemoBanner.module.scss';

export const ScheduleDemoBanner = () => {
  const { t } = useTranslation(['stream']);

  return (
    <div className={styles.scheduleDemoBannerRoot} data-clipboard-preserve>
      <div className={styles.illustration}>
        <EmptyInsights />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{t('stream:scheduleDemo.title')}</h3>
        <p className={styles.description}>
          {t('stream:scheduleDemo.description')}
        </p>
        <a
          className={styles.styledLink}
          href={config.urls.onboardingUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('stream:scheduleDemo.button')}
        </a>
      </div>
    </div>
  );
};
